import * as React from 'react';
import { useReporting } from '../../hooks/useReporting';
import moment from 'moment';
import { ChartsPaletteIndex } from '../../@shared/palette';
import "react-datepicker/dist/react-datepicker.css";
import { ChartItem } from '../../hooks/useCharts';
import LineChartComponent from '../../components/LineChart';
import { ReportingProviderInstance } from '../../@shared/services/ReportingProvider';
import { ReportingWithIdModel } from '../../@shared/Models/Reporting/ReportingWithIdModel';


export type TabsContentMonitoringModelUsageProps = {
  schemaId: string;
}

const TabsContentMonitoringSchemaCpuUsage = (props: TabsContentMonitoringModelUsageProps) => {
  const _reportingProviderInstance = React.useMemo(() => ReportingProviderInstance, []);

  const reportingHook = useReporting({
    onLoadData: async (input) => {
      return await _reportingProviderInstance.schemasCpu(input as ReportingWithIdModel);
    }
  });

  const items = React.useMemo((): ChartItem[] => {
    if (!reportingHook.dataResults?.data || reportingHook.isLoadingDataset) {
      return [];
    }

    return Object.keys(reportingHook.dataResults.data).map((key, index) => {
      return {
        label: "CPU Time",
        color: ChartsPaletteIndex[index],
        key: key,
        postfix: "s"
      } as ChartItem;
    });
  }, [reportingHook.dataResults?.data, reportingHook.isLoadingDataset]);

  React.useEffect(() => {
    reportingHook.onLoadDataset(props.schemaId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.schemaId, reportingHook.baseRequest]);


  const data = React.useMemo(() => {
    if (!reportingHook.dataResults?.data || reportingHook.isLoadingDataset) {
      return [];
    }
    const firstItem = reportingHook.dataResults!.data![Object.keys(reportingHook.dataResults!.data)[0]];
    if (!firstItem) return [];
    const result = firstItem.map((item, index) => {
      return {
        name: reportingHook.baseRequest.granularityInMinutes >= 1440 ? moment(item.date).format("MMM DD") : moment(item.date).format("MMM DD H:mm"),
        ...Object.keys(reportingHook.dataResults!.data!).reduce((acc, key) => {
          acc[key] = +(reportingHook.dataResults!.data![key][index].value / 1000).toFixed(2);
          return acc;
        }, {} as { [key: string]: any })
      }
    });

    return result;
  }, [reportingHook.baseRequest.granularityInMinutes, reportingHook.dataResults, reportingHook.isLoadingDataset]);

  return <LineChartComponent {...reportingHook} items={items} data={data} title='CPU Time' />
}

export default TabsContentMonitoringSchemaCpuUsage;
